import { render, staticRenderFns } from "./FormProductCategory.vue?vue&type=template&id=34214f36&scoped=true"
import script from "./FormProductCategory.vue?vue&type=script&lang=js"
export * from "./FormProductCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34214f36",
  null
  
)

export default component.exports